/**
 * Swiper Initialization on Cards
 *
 * It is designed for the cards in hotel listings only.
 * If more use cases arise it might be great to import this in cards_behavior.js
 */

import '../../vendors/swiper/swiper.scss'

import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

let touchstartX = 0
let touchendX = 0

// Init swiper on first interaction (user clicks over swiper-next button) and load rest of images after that
$(document).on('click', '.hotel-list .horizontal-card .swiper-button-next.card-image-next', function () {
  const $this = $(this)
  const $card = $this.closest('.swiper-container.card-image')

  initSwiper($card)
})
// Init swiper on first interaction (drag left) and load rest of images after that
$(document).on('touchstart mousedown', '.hotel-list .horizontal-card .swiper-slide', function (event) {
  touchstartX = event.pageX ? event.pageX : event.originalEvent.touches[0].clientX
})

$(document).on('touchend mouseup', '.hotel-list .horizontal-card .swiper-slide', function (event) {
  const $this = $(this)
  const $card = $this.closest('.horizontal-card')
  const $swiperContainer = $card.find('.swiper-container.card-image')

  touchendX = event.pageX ? event.pageX : event.originalEvent.changedTouches[0].pageX

  if (touchendX < touchstartX) {
    // swiped left
    initSwiper($swiperContainer)
  } else if (touchendX > touchstartX) {
    // swiped right
  }
})

function initSwiper($swiperContainer) {
  // If swiper already init returns
  if ($swiperContainer.hasClass('initialized')) return
  $swiperContainer.addClass('initialized')
  // Init swiper
  Swiper.use([Navigation])

  const swiperGalleryId = `${new Date().getTime()}`
  $swiperContainer.attr('data-swiper', swiperGalleryId)

  const swiperCard = new Swiper(`[data-swiper="${swiperGalleryId}"]`, {
    navigation: {
      nextEl: $swiperContainer.parent().find('.card-image-next').get(0),
      prevEl: $swiperContainer.parent().find('.card-image-prev').get(0),
    },
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 3,
    },
  })

  // Load rest of images
  $swiperContainer.find('.hotel-image.hidden').removeClass('hidden')
  $swiperContainer.find('picture.hotel-image').each(function () {
    IB.lazyImg.loadImg(this)
  })

  // Positions slider on second slider (slider inits when user clicks over swiper-next button)
  swiperCard.slideTo(1)
}
